<i18n src="./translations"></i18n>

<template>
  <div class="pdp-tab-expandable-content">
    <div ref="preview" class="preview">
      <slot />
    </div>

    <button v-if="isOverflowing" class="more" type="button" @click="openDialog">
      {{ $t('pdp-tab-expandable-content.more-button') }}
    </button>

    <Dialog ref="dialog" :click-outside="true" :title="headline">
      <div class="dialog-content">
        <slot />
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from 'Components/02-molecules/dialog/Dialog.vue';

export default {
  name: 'PdpTabExpandableContent',
  components: { Dialog },
  props: {
    headline: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOverflowing: false,
    };
  },
  mounted() {
    this.$nextTick(this.updateOverflowingState);
  },
  methods: {
    openDialog() {
      this.$refs.dialog && this.$refs.dialog.show();
    },
    updateOverflowingState() {
      const previewEl = this.$refs.preview;
      if (!previewEl) {
        this.isOverflowing = false;
        return;
      }
      this.isOverflowing = previewEl.scrollHeight - previewEl.clientHeight > 1;
    },
  },
};
</script>

<style scoped lang="scss">
.pdp-tab-expandable-content {
  .preview {
    font-size: var(--font-size-M);
    line-height: var(--font-size-MLL);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    line-clamp: 4;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .more {
    margin-top: var(--space-1);
    margin-bottom: var(--space-1);
    appearance: none;
    background: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
    color: var(--color-secondary);
    text-decoration: underline;
    font-size: var(--font-size-M);
    line-height: var(--font-size-MLL);
  }
}

.dialog-content {
  font-size: var(--font-size-M);
  line-height: var(--font-size-MLL);

  ::v-deep {
    a {
      color: var(--color-secondary);
      text-decoration: underline;
    }

    p + p {
      margin-top: 1em;
    }
  }
}
</style>
